import type { DepositLookupResponse } from '@massilia/queries'

import { useNavigate } from '@tanstack/react-router'
import { useState } from 'react'

import { DepositBookingInfo } from './deposit-booking-info'
import { DepositLookupForm } from './deposit-lookup-form'

interface BookingState {
  booking: DepositLookupResponse
  credentials: { dossierNumber: string; email: string; lastName: string }
}

interface DepositPaymentPageProps {
  initialValues?: {
    dossierNumber?: string
    email?: string
    lastName?: string
  }
  /**
   * Moyen de règlement visé à l'arrivée sur la page. `installments` vient du bouton
   * « Payer en 3/4x » du PDF de contrat et de l'espace client : il survit à la recherche
   * automatique du dossier pour arriver jusqu'au choix du moyen de paiement.
   */
  mode?: 'installments'
}

export function DepositPaymentPage({ initialValues, mode }: DepositPaymentPageProps) {
  const [bookingState, setBookingState] = useState<BookingState | null>(null)
  const navigate = useNavigate()

  if (bookingState) {
    const handleBack = async () => {
      await navigate({ to: '/payer-acompte' })
      setBookingState(null)
    }

    return (
      <DepositBookingInfo
        booking={bookingState.booking}
        credentials={bookingState.credentials}
        onBack={() => {
          void handleBack()
        }}
        requestedInstallments={mode === 'installments'}
      />
    )
  }

  return (
    <DepositLookupForm
      initialValues={initialValues}
      mode={mode}
      onBookingFound={(booking, credentials) => setBookingState({ booking, credentials })}
    />
  )
}
